// This file is generated by scripts/generate-asset-preload-manifest.mjs.
// Do not edit by hand.
export const ASSET_PRELOAD_MANIFEST = [
  {
    "url": "./assets/audio/music/Ally%20Theme.mp3",
    "kind": "audio",
    "byteSize": 4633903
  },
  {
    "url": "./assets/audio/music/Ashes%20To%20Ashes%20-%20Main%20Theme.mp3",
    "kind": "audio",
    "byteSize": 7196292
  },
  {
    "url": "./assets/audio/music/Enemy%20Theme.mp3",
    "kind": "audio",
    "byteSize": 4475879
  },
  {
    "url": "./assets/audio/music/Super%20Nova%20-%20Nova's%20Theme.mp3",
    "kind": "audio",
    "byteSize": 4938452
  },
  {
    "url": "./assets/audio/music/The%20House%20Always%20Wins%20-%20Rook's%20Theme.mp3",
    "kind": "audio",
    "byteSize": 3257002
  },
  {
    "url": "./assets/audio/sfx/commander/atlas.wav",
    "kind": "audio",
    "byteSize": 83834
  },
  {
    "url": "./assets/audio/sfx/commander/blaze.wav",
    "kind": "audio",
    "byteSize": 90008
  },
  {
    "url": "./assets/audio/sfx/commander/echo.wav",
    "kind": "audio",
    "byteSize": 79424
  },
  {
    "url": "./assets/audio/sfx/commander/falcon.wav",
    "kind": "audio",
    "byteSize": 82952
  },
  {
    "url": "./assets/audio/sfx/commander/graves.wav",
    "kind": "audio",
    "byteSize": 89126
  },
  {
    "url": "./assets/audio/sfx/commander/knox.wav",
    "kind": "audio",
    "byteSize": 84716
  },
  {
    "url": "./assets/audio/sfx/commander/nova.wav",
    "kind": "audio",
    "byteSize": 86480
  },
  {
    "url": "./assets/audio/sfx/commander/rook.wav",
    "kind": "audio",
    "byteSize": 86480
  },
  {
    "url": "./assets/audio/sfx/commander/sable.wav",
    "kind": "audio",
    "byteSize": 81188
  },
  {
    "url": "./assets/audio/sfx/commander/viper.wav",
    "kind": "audio",
    "byteSize": 82070
  },
  {
    "url": "./assets/audio/sfx/impact/critical.wav",
    "kind": "audio",
    "byteSize": 37088
  },
  {
    "url": "./assets/audio/sfx/impact/destroyed.wav",
    "kind": "audio",
    "byteSize": 57374
  },
  {
    "url": "./assets/audio/sfx/impact/effective.wav",
    "kind": "audio",
    "byteSize": 31796
  },
  {
    "url": "./assets/audio/sfx/impact/glance.wav",
    "kind": "audio",
    "byteSize": 16802
  },
  {
    "url": "./assets/audio/sfx/impact/hit.wav",
    "kind": "audio",
    "byteSize": 23858
  },
  {
    "url": "./assets/audio/sfx/impact/miss.wav",
    "kind": "audio",
    "byteSize": 18566
  },
  {
    "url": "./assets/audio/sfx/movement/air-loop.wav",
    "kind": "audio",
    "byteSize": 56492
  },
  {
    "url": "./assets/audio/sfx/movement/infantry-loop.wav",
    "kind": "audio",
    "byteSize": 37970
  },
  {
    "url": "./assets/audio/sfx/movement/teleport-arrive.wav",
    "kind": "audio",
    "byteSize": 20330
  },
  {
    "url": "./assets/audio/sfx/movement/teleport-depart.wav",
    "kind": "audio",
    "byteSize": 18566
  },
  {
    "url": "./assets/audio/sfx/movement/tracked-loop.wav",
    "kind": "audio",
    "byteSize": 52964
  },
  {
    "url": "./assets/audio/sfx/movement/wheeled-loop.wav",
    "kind": "audio",
    "byteSize": 45908
  },
  {
    "url": "./assets/audio/sfx/outcome/defeat.wav",
    "kind": "audio",
    "byteSize": 149984
  },
  {
    "url": "./assets/audio/sfx/outcome/run-complete.wav",
    "kind": "audio",
    "byteSize": 202904
  },
  {
    "url": "./assets/audio/sfx/outcome/victory.wav",
    "kind": "audio",
    "byteSize": 158804
  },
  {
    "url": "./assets/audio/sfx/progression/level-up.wav",
    "kind": "audio",
    "byteSize": 92654
  },
  {
    "url": "./assets/audio/sfx/progression/reward.wav",
    "kind": "audio",
    "byteSize": 63548
  },
  {
    "url": "./assets/audio/sfx/progression/stat-gain.wav",
    "kind": "audio",
    "byteSize": 14156
  },
  {
    "url": "./assets/audio/sfx/progression/xp-gain.wav",
    "kind": "audio",
    "byteSize": 18566
  },
  {
    "url": "./assets/audio/sfx/progression/xp-threshold.wav",
    "kind": "audio",
    "byteSize": 26504
  },
  {
    "url": "./assets/audio/sfx/support/field-medpack.wav",
    "kind": "audio",
    "byteSize": 41498
  },
  {
    "url": "./assets/audio/sfx/support/hospital.wav",
    "kind": "audio",
    "byteSize": 58256
  },
  {
    "url": "./assets/audio/sfx/support/hq.wav",
    "kind": "audio",
    "byteSize": 53846
  },
  {
    "url": "./assets/audio/sfx/support/mechanic.wav",
    "kind": "audio",
    "byteSize": 47672
  },
  {
    "url": "./assets/audio/sfx/support/medic.wav",
    "kind": "audio",
    "byteSize": 45908
  },
  {
    "url": "./assets/audio/sfx/support/passive.wav",
    "kind": "audio",
    "byteSize": 33560
  },
  {
    "url": "./assets/audio/sfx/support/repair-station.wav",
    "kind": "audio",
    "byteSize": 60020
  },
  {
    "url": "./assets/audio/sfx/support/resupply.wav",
    "kind": "audio",
    "byteSize": 40616
  },
  {
    "url": "./assets/audio/sfx/support/run-card.wav",
    "kind": "audio",
    "byteSize": 45908
  },
  {
    "url": "./assets/audio/sfx/support/sector.wav",
    "kind": "audio",
    "byteSize": 39734
  },
  {
    "url": "./assets/audio/sfx/transport/runner-board.wav",
    "kind": "audio",
    "byteSize": 36206
  },
  {
    "url": "./assets/audio/sfx/transport/runner-unload.wav",
    "kind": "audio",
    "byteSize": 38852
  },
  {
    "url": "./assets/audio/sfx/ui/adjust.wav",
    "kind": "audio",
    "byteSize": 7982
  },
  {
    "url": "./assets/audio/sfx/ui/cancel.wav",
    "kind": "audio",
    "byteSize": 14156
  },
  {
    "url": "./assets/audio/sfx/ui/confirm.wav",
    "kind": "audio",
    "byteSize": 13274
  },
  {
    "url": "./assets/audio/sfx/ui/danger.wav",
    "kind": "audio",
    "byteSize": 20330
  },
  {
    "url": "./assets/audio/sfx/ui/grid-cursor.wav",
    "kind": "audio",
    "byteSize": 4896
  },
  {
    "url": "./assets/audio/sfx/ui/hover.wav",
    "kind": "audio",
    "byteSize": 6218
  },
  {
    "url": "./assets/audio/sfx/ui/move-confirm.wav",
    "kind": "audio",
    "byteSize": 12834
  },
  {
    "url": "./assets/audio/sfx/ui/target-invalid.wav",
    "kind": "audio",
    "byteSize": 15920
  },
  {
    "url": "./assets/audio/sfx/ui/target-mode.wav",
    "kind": "audio",
    "byteSize": 13274
  },
  {
    "url": "./assets/audio/sfx/ui/target-valid.wav",
    "kind": "audio",
    "byteSize": 12834
  },
  {
    "url": "./assets/audio/sfx/ui/unit-deselect.wav",
    "kind": "audio",
    "byteSize": 10628
  },
  {
    "url": "./assets/audio/sfx/ui/unit-select.wav",
    "kind": "audio",
    "byteSize": 11952
  },
  {
    "url": "./assets/audio/sfx/weapons/aa-gear.wav",
    "kind": "audio",
    "byteSize": 42380
  },
  {
    "url": "./assets/audio/sfx/weapons/autocannon.wav",
    "kind": "audio",
    "byteSize": 27386
  },
  {
    "url": "./assets/audio/sfx/weapons/breaker-charge.wav",
    "kind": "audio",
    "byteSize": 45908
  },
  {
    "url": "./assets/audio/sfx/weapons/bruiser-cannon.wav",
    "kind": "audio",
    "byteSize": 36206
  },
  {
    "url": "./assets/audio/sfx/weapons/flak-cannon.wav",
    "kind": "audio",
    "byteSize": 33560
  },
  {
    "url": "./assets/audio/sfx/weapons/heavy-cannon.wav",
    "kind": "audio",
    "byteSize": 45908
  },
  {
    "url": "./assets/audio/sfx/weapons/interceptor-cannons.wav",
    "kind": "audio",
    "byteSize": 24740
  },
  {
    "url": "./assets/audio/sfx/weapons/marksman-rifle.wav",
    "kind": "audio",
    "byteSize": 29150
  },
  {
    "url": "./assets/audio/sfx/weapons/payload-bombs.wav",
    "kind": "audio",
    "byteSize": 79424
  },
  {
    "url": "./assets/audio/sfx/weapons/rifle.wav",
    "kind": "audio",
    "byteSize": 15038
  },
  {
    "url": "./assets/audio/sfx/weapons/rocket-pods.wav",
    "kind": "audio",
    "byteSize": 54728
  },
  {
    "url": "./assets/audio/sfx/weapons/secondary-fire.wav",
    "kind": "audio",
    "byteSize": 19890
  },
  {
    "url": "./assets/audio/sfx/weapons/sidearm.wav",
    "kind": "audio",
    "byteSize": 12834
  },
  {
    "url": "./assets/audio/sfx/weapons/siege-artillery.wav",
    "kind": "audio",
    "byteSize": 63548
  },
  {
    "url": "./assets/audio/sfx/weapons/tool-rifle.wav",
    "kind": "audio",
    "byteSize": 16802
  },
  {
    "url": "./assets/audio/sfx/world/burn.wav",
    "kind": "audio",
    "byteSize": 49436
  },
  {
    "url": "./assets/audio/sfx/world/capture.wav",
    "kind": "audio",
    "byteSize": 66194
  },
  {
    "url": "./assets/audio/sfx/world/deployment.wav",
    "kind": "audio",
    "byteSize": 49436
  },
  {
    "url": "./assets/audio/sfx/world/drop-off.wav",
    "kind": "audio",
    "byteSize": 74132
  },
  {
    "url": "./assets/audio/sfx/world/extinguish.wav",
    "kind": "audio",
    "byteSize": 51200
  },
  {
    "url": "./assets/audio/sfx/world/objective.wav",
    "kind": "audio",
    "byteSize": 60902
  },
  {
    "url": "./assets/audio/sfx/world/reinforcements.wav",
    "kind": "audio",
    "byteSize": 72368
  },
  {
    "url": "./assets/audio/sfx/world/rescue.wav",
    "kind": "audio",
    "byteSize": 61784
  },
  {
    "url": "./assets/audio/sfx/world/sabotage.wav",
    "kind": "audio",
    "byteSize": 60902
  },
  {
    "url": "./assets/audio/sfx/world/status-damage.wav",
    "kind": "audio",
    "byteSize": 31796
  },
  {
    "url": "./assets/audio/sfx/world/turn-end.wav",
    "kind": "audio",
    "byteSize": 33560
  },
  {
    "url": "./assets/audio/sfx/world/turn-enemy.wav",
    "kind": "audio",
    "byteSize": 54728
  },
  {
    "url": "./assets/audio/sfx/world/turn-player.wav",
    "kind": "audio",
    "byteSize": 54728
  },
  {
    "url": "./assets/cursor/retrowave_arrow.cur",
    "kind": "cursor",
    "byteSize": 4286
  },
  {
    "url": "./assets/cursor/retrowave_beam.cur",
    "kind": "cursor",
    "byteSize": 4286
  },
  {
    "url": "./assets/cursor/retrowave_busy.ani",
    "kind": "cursor",
    "byteSize": 64614
  },
  {
    "url": "./assets/cursor/retrowave_cross.cur",
    "kind": "cursor",
    "byteSize": 4286
  },
  {
    "url": "./assets/cursor/retrowave_ew.ani",
    "kind": "cursor",
    "byteSize": 21578
  },
  {
    "url": "./assets/cursor/retrowave_help.cur",
    "kind": "cursor",
    "byteSize": 4286
  },
  {
    "url": "./assets/cursor/retrowave_link.ani",
    "kind": "cursor",
    "byteSize": 17244
  },
  {
    "url": "./assets/cursor/retrowave_move.ani",
    "kind": "cursor",
    "byteSize": 21578
  },
  {
    "url": "./assets/cursor/retrowave_nesw.ani",
    "kind": "cursor",
    "byteSize": 21578
  },
  {
    "url": "./assets/cursor/retrowave_ns.ani",
    "kind": "cursor",
    "byteSize": 21578
  },
  {
    "url": "./assets/cursor/retrowave_nwse.ani",
    "kind": "cursor",
    "byteSize": 21578
  },
  {
    "url": "./assets/cursor/retrowave_pen.cur",
    "kind": "cursor",
    "byteSize": 4286
  },
  {
    "url": "./assets/cursor/retrowave_unavail.cur",
    "kind": "cursor",
    "byteSize": 4286
  },
  {
    "url": "./assets/cursor/retrowave_up.ani",
    "kind": "cursor",
    "byteSize": 21578
  },
  {
    "url": "./assets/cursor/retrowave_wait.ani",
    "kind": "cursor",
    "byteSize": 17244
  },
  {
    "url": "./assets/fonts/orbitron/Orbitron-600.ttf",
    "kind": "font",
    "byteSize": 17796
  },
  {
    "url": "./assets/fonts/orbitron/Orbitron-700.ttf",
    "kind": "font",
    "byteSize": 17708
  },
  {
    "url": "./assets/fonts/orbitron/Orbitron-800.ttf",
    "kind": "font",
    "byteSize": 17768
  },
  {
    "url": "./assets/fonts/oxanium/Oxanium-400.ttf",
    "kind": "font",
    "byteSize": 28376
  },
  {
    "url": "./assets/fonts/oxanium/Oxanium-500.ttf",
    "kind": "font",
    "byteSize": 28420
  },
  {
    "url": "./assets/fonts/oxanium/Oxanium-600.ttf",
    "kind": "font",
    "byteSize": 28416
  },
  {
    "url": "./assets/fonts/oxanium/Oxanium-700.ttf",
    "kind": "font",
    "byteSize": 28332
  },
  {
    "url": "./assets/fonts/oxanium/Oxanium-800.ttf",
    "kind": "font",
    "byteSize": 28396
  },
  {
    "url": "./assets/img/commanders/atlas/Atlas%20-%20Info.png",
    "kind": "image",
    "byteSize": 2159905
  },
  {
    "url": "./assets/img/commanders/atlas/Atlas%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2210813
  },
  {
    "url": "./assets/img/commanders/blaze/Blaze%20-%20Info.png",
    "kind": "image",
    "byteSize": 2003816
  },
  {
    "url": "./assets/img/commanders/blaze/Blaze%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2092892
  },
  {
    "url": "./assets/img/commanders/echo/Echo%20-%20Info.png",
    "kind": "image",
    "byteSize": 2031370
  },
  {
    "url": "./assets/img/commanders/echo/Echo%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2050065
  },
  {
    "url": "./assets/img/commanders/falcon/Falcon%20-%20Info.png",
    "kind": "image",
    "byteSize": 2428210
  },
  {
    "url": "./assets/img/commanders/falcon/Falcon%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2318836
  },
  {
    "url": "./assets/img/commanders/graves/Graves%20-%20Info.png",
    "kind": "image",
    "byteSize": 1990959
  },
  {
    "url": "./assets/img/commanders/graves/Graves%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 1895884
  },
  {
    "url": "./assets/img/commanders/knox/Knox%20-%20Info.png",
    "kind": "image",
    "byteSize": 1995212
  },
  {
    "url": "./assets/img/commanders/knox/Knox%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2181128
  },
  {
    "url": "./assets/img/commanders/nova/Nova%20-%20Info.png",
    "kind": "image",
    "byteSize": 2372770
  },
  {
    "url": "./assets/img/commanders/nova/Nova%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2679562
  },
  {
    "url": "./assets/img/commanders/rook/Rook%20-%20Info.png",
    "kind": "image",
    "byteSize": 2161448
  },
  {
    "url": "./assets/img/commanders/rook/Rook%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2253561
  },
  {
    "url": "./assets/img/commanders/sables/Sables%20-%20Info.png",
    "kind": "image",
    "byteSize": 2014456
  },
  {
    "url": "./assets/img/commanders/sables/Sables%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2115458
  },
  {
    "url": "./assets/img/commanders/viper/Viper%20-%20Info.png",
    "kind": "image",
    "byteSize": 2018301
  },
  {
    "url": "./assets/img/commanders/viper/Viper%20-%20Portrait.png",
    "kind": "image",
    "byteSize": 2004859
  },
  {
    "url": "./assets/img/icons/battle-hud/armor/infantry.png",
    "kind": "image",
    "byteSize": 269539
  },
  {
    "url": "./assets/img/icons/battle-hud/armor/light.png",
    "kind": "image",
    "byteSize": 231716
  },
  {
    "url": "./assets/img/icons/battle-hud/armor/medium.png",
    "kind": "image",
    "byteSize": 291335
  },
  {
    "url": "./assets/img/icons/battle-hud/conditions/burn.png",
    "kind": "image",
    "byteSize": 195215
  },
  {
    "url": "./assets/img/icons/battle-hud/conditions/corrupted.png",
    "kind": "image",
    "byteSize": 188173
  },
  {
    "url": "./assets/img/icons/battle-hud/conditions/Image%20(16).png",
    "kind": "image",
    "byteSize": 269539
  },
  {
    "url": "./assets/img/icons/battle-hud/conditions/slow.png",
    "kind": "image",
    "byteSize": 213346
  },
  {
    "url": "./assets/img/icons/battle-hud/power-meter/empty.png",
    "kind": "image",
    "byteSize": 294463
  },
  {
    "url": "./assets/img/icons/battle-hud/power-meter/full.png",
    "kind": "image",
    "byteSize": 315994
  },
  {
    "url": "./assets/img/icons/battle-hud/power-meter/half.png",
    "kind": "image",
    "byteSize": 319751
  },
  {
    "url": "./assets/img/icons/battle-hud/power-meter/power-meter-empty-5.png",
    "kind": "image",
    "byteSize": 99377
  },
  {
    "url": "./assets/img/icons/battle-hud/power-meter/power-meter-empty-6.png",
    "kind": "image",
    "byteSize": 106405
  },
  {
    "url": "./assets/img/icons/battle-hud/power-meter/power-meter-empty-7.png",
    "kind": "image",
    "byteSize": 112767
  },
  {
    "url": "./assets/img/icons/battle-hud/power-meter/power-meter-empty.png",
    "kind": "image",
    "byteSize": 202914
  },
  {
    "url": "./assets/img/icons/battle-hud/stats/ammo.png",
    "kind": "image",
    "byteSize": 187627
  },
  {
    "url": "./assets/img/icons/battle-hud/stats/arm.png",
    "kind": "image",
    "byteSize": 241283
  },
  {
    "url": "./assets/img/icons/battle-hud/stats/atk.png",
    "kind": "image",
    "byteSize": 215652
  },
  {
    "url": "./assets/img/icons/battle-hud/stats/mov.png",
    "kind": "image",
    "byteSize": 184423
  },
  {
    "url": "./assets/img/icons/battle-hud/stats/rng.png",
    "kind": "image",
    "byteSize": 237068
  },
  {
    "url": "./assets/img/icons/battle-hud/stats/sta.png",
    "kind": "image",
    "byteSize": 205610
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/autocannon.png",
    "kind": "image",
    "byteSize": 193829
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/breaker-charge.png",
    "kind": "image",
    "byteSize": 160478
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/bruiser-cannon.png",
    "kind": "image",
    "byteSize": 220618
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/flak-cannon.png",
    "kind": "image",
    "byteSize": 238186
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/heavy-cannon.png",
    "kind": "image",
    "byteSize": 258697
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/interceptor-cannons.png",
    "kind": "image",
    "byteSize": 247010
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/marksman-rifle.png",
    "kind": "image",
    "byteSize": 153839
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/payload-bombs.png",
    "kind": "image",
    "byteSize": 153839
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/rifle.png",
    "kind": "image",
    "byteSize": 148295
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/rocket-pods.png",
    "kind": "image",
    "byteSize": 243106
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/sidearm.png",
    "kind": "image",
    "byteSize": 174947
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/siege-artillery.png",
    "kind": "image",
    "byteSize": 249985
  },
  {
    "url": "./assets/img/icons/battle-hud/weapons/tool-rifle.png",
    "kind": "image",
    "byteSize": 185671
  },
  {
    "url": "./assets/img/logos/articus.png",
    "kind": "image",
    "byteSize": 47588
  },
  {
    "url": "./assets/img/logos/ash-run-84-logo.png",
    "kind": "image",
    "byteSize": 398008
  },
  {
    "url": "./assets/img/logos/logo.png",
    "kind": "image",
    "byteSize": 398008
  },
  {
    "url": "./assets/img/splash/splash-background.png",
    "kind": "image",
    "byteSize": 1857594
  },
  {
    "url": "./assets/img/ui/background/_battlefield-bg.png",
    "kind": "image",
    "byteSize": 1648749
  },
  {
    "url": "./assets/img/ui/background/battlefield-bg.png",
    "kind": "image",
    "byteSize": 2437152
  },
  {
    "url": "./assets/img/ui/background/commander-ability.png",
    "kind": "image",
    "byteSize": 130926
  },
  {
    "url": "./assets/img/ui/background/commander-trait.png",
    "kind": "image",
    "byteSize": 90963
  },
  {
    "url": "./assets/img/ui/background/commander.png",
    "kind": "image",
    "byteSize": 1663565
  },
  {
    "url": "./assets/img/ui/background/portrait-frame.png",
    "kind": "image",
    "byteSize": 182200
  },
  {
    "url": "./assets/img/ui/background/powers.png",
    "kind": "image",
    "byteSize": 289285
  },
  {
    "url": "./assets/img/ui/background/sidebar.png",
    "kind": "image",
    "byteSize": 1485165
  },
  {
    "url": "./assets/img/ui/buttons/continue.png",
    "kind": "image",
    "byteSize": 361312
  },
  {
    "url": "./assets/img/ui/buttons/end-turn.png",
    "kind": "image",
    "byteSize": 175373
  },
  {
    "url": "./assets/img/ui/buttons/map-editor.png",
    "kind": "image",
    "byteSize": 360201
  },
  {
    "url": "./assets/img/ui/buttons/new-run.png",
    "kind": "image",
    "byteSize": 362259
  },
  {
    "url": "./assets/img/ui/buttons/next.png",
    "kind": "image",
    "byteSize": 187097
  },
  {
    "url": "./assets/img/ui/buttons/pause.png",
    "kind": "image",
    "byteSize": 160504
  },
  {
    "url": "./assets/img/ui/buttons/progression.png",
    "kind": "image",
    "byteSize": 318834
  },
  {
    "url": "./assets/img/ui/buttons/quit-game.png",
    "kind": "image",
    "byteSize": 359914
  },
  {
    "url": "./assets/img/ui/buttons/sandbox.png",
    "kind": "image",
    "byteSize": 362700
  },
  {
    "url": "./assets/img/ui/buttons/settings.png",
    "kind": "image",
    "byteSize": 371948
  },
  {
    "url": "./assets/img/ui/buttons/skirmish.png",
    "kind": "image",
    "byteSize": 365167
  },
  {
    "url": "./assets/img/ui/buttons/tutorial.png",
    "kind": "image",
    "byteSize": 357648
  },
  {
    "url": "./assets/img/upgrade-cards/1_common.png",
    "kind": "image",
    "byteSize": 269499
  },
  {
    "url": "./assets/img/upgrade-cards/1738856685327.jpg",
    "kind": "image",
    "byteSize": 24359
  },
  {
    "url": "./assets/img/upgrade-cards/2_uncommon.png",
    "kind": "image",
    "byteSize": 400552
  },
  {
    "url": "./assets/img/upgrade-cards/3_rare.png",
    "kind": "image",
    "byteSize": 445295
  },
  {
    "url": "./assets/img/upgrade-cards/4_epic.png",
    "kind": "image",
    "byteSize": 492454
  },
  {
    "url": "./assets/img/upgrade-cards/5_mythic.png",
    "kind": "image",
    "byteSize": 565078
  },
  {
    "url": "./assets/img/upgrade-cards/6_legendary.png",
    "kind": "image",
    "byteSize": 538257
  },
  {
    "url": "./assets/main.css",
    "kind": "style",
    "byteSize": 1,
    "environment": "production"
  },
  {
    "url": "./assets/main.js",
    "kind": "script",
    "byteSize": 1,
    "environment": "production"
  },
  {
    "url": "./assets/sprites/buildings/enemy/airfield.svg",
    "kind": "image",
    "byteSize": 533
  },
  {
    "url": "./assets/sprites/buildings/enemy/barracks.svg",
    "kind": "image",
    "byteSize": 535
  },
  {
    "url": "./assets/sprites/buildings/enemy/command.png",
    "kind": "image",
    "byteSize": 1872
  },
  {
    "url": "./assets/sprites/buildings/enemy/command.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/enemy/hospital.png",
    "kind": "image",
    "byteSize": 1569
  },
  {
    "url": "./assets/sprites/buildings/enemy/hospital.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/enemy/motor-pool.svg",
    "kind": "image",
    "byteSize": 597
  },
  {
    "url": "./assets/sprites/buildings/enemy/repair-station.svg",
    "kind": "image",
    "byteSize": 597
  },
  {
    "url": "./assets/sprites/buildings/enemy/sector.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/neutral/airfield.svg",
    "kind": "image",
    "byteSize": 533
  },
  {
    "url": "./assets/sprites/buildings/neutral/barracks.svg",
    "kind": "image",
    "byteSize": 535
  },
  {
    "url": "./assets/sprites/buildings/neutral/command.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/neutral/hospital.png",
    "kind": "image",
    "byteSize": 1491
  },
  {
    "url": "./assets/sprites/buildings/neutral/hospital.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/neutral/motor-pool.svg",
    "kind": "image",
    "byteSize": 597
  },
  {
    "url": "./assets/sprites/buildings/neutral/repair-station.svg",
    "kind": "image",
    "byteSize": 597
  },
  {
    "url": "./assets/sprites/buildings/neutral/sector.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/player/airfield.svg",
    "kind": "image",
    "byteSize": 533
  },
  {
    "url": "./assets/sprites/buildings/player/barracks.svg",
    "kind": "image",
    "byteSize": 535
  },
  {
    "url": "./assets/sprites/buildings/player/command.png",
    "kind": "image",
    "byteSize": 7641
  },
  {
    "url": "./assets/sprites/buildings/player/command.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/player/hospital.png",
    "kind": "image",
    "byteSize": 1557
  },
  {
    "url": "./assets/sprites/buildings/player/hospital.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/buildings/player/motor-pool.svg",
    "kind": "image",
    "byteSize": 597
  },
  {
    "url": "./assets/sprites/buildings/player/repair-station.svg",
    "kind": "image",
    "byteSize": 597
  },
  {
    "url": "./assets/sprites/buildings/player/sector.svg",
    "kind": "image",
    "byteSize": 534
  },
  {
    "url": "./assets/sprites/terrain/__plain.png",
    "kind": "image",
    "byteSize": 1397303
  },
  {
    "url": "./assets/sprites/terrain/_mountain.png",
    "kind": "image",
    "byteSize": 2175
  },
  {
    "url": "./assets/sprites/terrain/bridge_start.png",
    "kind": "image",
    "byteSize": 185028
  },
  {
    "url": "./assets/sprites/terrain/bridge.png",
    "kind": "image",
    "byteSize": 141834
  },
  {
    "url": "./assets/sprites/terrain/edge.png",
    "kind": "image",
    "byteSize": 625092
  },
  {
    "url": "./assets/sprites/terrain/forest_1x2.png",
    "kind": "image",
    "byteSize": 304871
  },
  {
    "url": "./assets/sprites/terrain/forest_2x1.png",
    "kind": "image",
    "byteSize": 322382
  },
  {
    "url": "./assets/sprites/terrain/forest_2x2.png",
    "kind": "image",
    "byteSize": 290974
  },
  {
    "url": "./assets/sprites/terrain/forest.png",
    "kind": "image",
    "byteSize": 22244
  },
  {
    "url": "./assets/sprites/terrain/forest.svg",
    "kind": "image",
    "byteSize": 656
  },
  {
    "url": "./assets/sprites/terrain/mountain_1x2.png",
    "kind": "image",
    "byteSize": 438975
  },
  {
    "url": "./assets/sprites/terrain/mountain_2x1.png",
    "kind": "image",
    "byteSize": 378686
  },
  {
    "url": "./assets/sprites/terrain/mountain_2x2.png",
    "kind": "image",
    "byteSize": 440685
  },
  {
    "url": "./assets/sprites/terrain/mountain.png",
    "kind": "image",
    "byteSize": 30892
  },
  {
    "url": "./assets/sprites/terrain/mountain.svg",
    "kind": "image",
    "byteSize": 442
  },
  {
    "url": "./assets/sprites/terrain/plain.png",
    "kind": "image",
    "byteSize": 1248
  },
  {
    "url": "./assets/sprites/terrain/plain.svg",
    "kind": "image",
    "byteSize": 594
  },
  {
    "url": "./assets/sprites/terrain/plain/_plain.png",
    "kind": "image",
    "byteSize": 1004884
  },
  {
    "url": "./assets/sprites/terrain/ridge.svg",
    "kind": "image",
    "byteSize": 597
  },
  {
    "url": "./assets/sprites/terrain/road.png",
    "kind": "image",
    "byteSize": 1290
  },
  {
    "url": "./assets/sprites/terrain/road.svg",
    "kind": "image",
    "byteSize": 588
  },
  {
    "url": "./assets/sprites/terrain/road/road.png",
    "kind": "image",
    "byteSize": 14790
  },
  {
    "url": "./assets/sprites/terrain/roadside.png",
    "kind": "image",
    "byteSize": 495182
  },
  {
    "url": "./assets/sprites/terrain/shoal.png",
    "kind": "image",
    "byteSize": 117401
  },
  {
    "url": "./assets/sprites/terrain/water.png",
    "kind": "image",
    "byteSize": 1150296
  },
  {
    "url": "./assets/sprites/terrain/water.svg",
    "kind": "image",
    "byteSize": 592
  },
  {
    "url": "./assets/sprites/terrain/water/water.png",
    "kind": "image",
    "byteSize": 1302091
  },
  {
    "url": "./assets/sprites/units/blue/breaker.svg",
    "kind": "image",
    "byteSize": 726
  },
  {
    "url": "./assets/sprites/units/blue/breaker/breaker-attack.png",
    "kind": "image",
    "byteSize": 6516
  },
  {
    "url": "./assets/sprites/units/blue/breaker/breaker-idle.png",
    "kind": "image",
    "byteSize": 3846
  },
  {
    "url": "./assets/sprites/units/blue/breaker/breaker-move.png",
    "kind": "image",
    "byteSize": 12654
  },
  {
    "url": "./assets/sprites/units/blue/bruiser.svg",
    "kind": "image",
    "byteSize": 58896
  },
  {
    "url": "./assets/sprites/units/blue/bruiser/bruiser-full.png",
    "kind": "image",
    "byteSize": 101934
  },
  {
    "url": "./assets/sprites/units/blue/carrier.svg",
    "kind": "image",
    "byteSize": 667
  },
  {
    "url": "./assets/sprites/units/blue/grunt.svg",
    "kind": "image",
    "byteSize": 668
  },
  {
    "url": "./assets/sprites/units/blue/grunt/grunt-attack.png",
    "kind": "image",
    "byteSize": 6054
  },
  {
    "url": "./assets/sprites/units/blue/grunt/grunt-idle.png",
    "kind": "image",
    "byteSize": 3615
  },
  {
    "url": "./assets/sprites/units/blue/grunt/grunt-move.png",
    "kind": "image",
    "byteSize": 13977
  },
  {
    "url": "./assets/sprites/units/blue/gunship.svg",
    "kind": "image",
    "byteSize": 664
  },
  {
    "url": "./assets/sprites/units/blue/gunship/gunship-attack.png",
    "kind": "image",
    "byteSize": 5907
  },
  {
    "url": "./assets/sprites/units/blue/gunship/gunship-idle.png",
    "kind": "image",
    "byteSize": 4269
  },
  {
    "url": "./assets/sprites/units/blue/gunship/gunship-move.png",
    "kind": "image",
    "byteSize": 17562
  },
  {
    "url": "./assets/sprites/units/blue/interceptor.svg",
    "kind": "image",
    "byteSize": 606
  },
  {
    "url": "./assets/sprites/units/blue/interceptor/interceptor-full.png",
    "kind": "image",
    "byteSize": 166155
  },
  {
    "url": "./assets/sprites/units/blue/juggernaut.svg",
    "kind": "image",
    "byteSize": 733
  },
  {
    "url": "./assets/sprites/units/blue/juggernaut/juggernaut-attack.png",
    "kind": "image",
    "byteSize": 4980
  },
  {
    "url": "./assets/sprites/units/blue/juggernaut/juggernaut-idle.png",
    "kind": "image",
    "byteSize": 4785
  },
  {
    "url": "./assets/sprites/units/blue/juggernaut/juggernaut-move.png",
    "kind": "image",
    "byteSize": 12045
  },
  {
    "url": "./assets/sprites/units/blue/longshot.svg",
    "kind": "image",
    "byteSize": 669
  },
  {
    "url": "./assets/sprites/units/blue/longshot/longshot-attack.png",
    "kind": "image",
    "byteSize": 16203
  },
  {
    "url": "./assets/sprites/units/blue/longshot/longshot-idle.png",
    "kind": "image",
    "byteSize": 4473
  },
  {
    "url": "./assets/sprites/units/blue/longshot/longshot-move.png",
    "kind": "image",
    "byteSize": 14982
  },
  {
    "url": "./assets/sprites/units/blue/mechanic.svg",
    "kind": "image",
    "byteSize": 1280
  },
  {
    "url": "./assets/sprites/units/blue/mechanic/mechanic-full.png",
    "kind": "image",
    "byteSize": 29826
  },
  {
    "url": "./assets/sprites/units/blue/medic.svg",
    "kind": "image",
    "byteSize": 1276
  },
  {
    "url": "./assets/sprites/units/blue/medic/medic-attack.png",
    "kind": "image",
    "byteSize": 6363
  },
  {
    "url": "./assets/sprites/units/blue/medic/medic-idle.png",
    "kind": "image",
    "byteSize": 3603
  },
  {
    "url": "./assets/sprites/units/blue/medic/medic-move.png",
    "kind": "image",
    "byteSize": 11931
  },
  {
    "url": "./assets/sprites/units/blue/payload.svg",
    "kind": "image",
    "byteSize": 665
  },
  {
    "url": "./assets/sprites/units/blue/payload/payload-full.png",
    "kind": "image",
    "byteSize": 18876
  },
  {
    "url": "./assets/sprites/units/blue/runner.svg",
    "kind": "image",
    "byteSize": 667
  },
  {
    "url": "./assets/sprites/units/blue/runner/runner-attack.png",
    "kind": "image",
    "byteSize": 7299
  },
  {
    "url": "./assets/sprites/units/blue/runner/runner-idle.png",
    "kind": "image",
    "byteSize": 8685
  },
  {
    "url": "./assets/sprites/units/blue/runner/runner-move.png",
    "kind": "image",
    "byteSize": 15918
  },
  {
    "url": "./assets/sprites/units/blue/siege-gun.svg",
    "kind": "image",
    "byteSize": 668
  },
  {
    "url": "./assets/sprites/units/blue/siege-gun/siege-gun-full.png",
    "kind": "image",
    "byteSize": 30177
  },
  {
    "url": "./assets/sprites/units/blue/skyguard.svg",
    "kind": "image",
    "byteSize": 669
  },
  {
    "url": "./assets/sprites/units/blue/skyguard/skyguard-attack.png",
    "kind": "image",
    "byteSize": 7656
  },
  {
    "url": "./assets/sprites/units/blue/skyguard/skyguard-idle.png",
    "kind": "image",
    "byteSize": 12873
  },
  {
    "url": "./assets/sprites/units/blue/skyguard/skyguard-move.png",
    "kind": "image",
    "byteSize": 21513
  },
  {
    "url": "./assets/sprites/units/green/breaker/breaker-attack.png",
    "kind": "image",
    "byteSize": 6405
  },
  {
    "url": "./assets/sprites/units/green/breaker/breaker-idle.png",
    "kind": "image",
    "byteSize": 3780
  },
  {
    "url": "./assets/sprites/units/green/breaker/breaker-move.png",
    "kind": "image",
    "byteSize": 12405
  },
  {
    "url": "./assets/sprites/units/green/bruiser/bruiser-full.png",
    "kind": "image",
    "byteSize": 99000
  },
  {
    "url": "./assets/sprites/units/green/carrier.svg",
    "kind": "image",
    "byteSize": 667
  },
  {
    "url": "./assets/sprites/units/green/grunt/grunt-attack.png",
    "kind": "image",
    "byteSize": 5856
  },
  {
    "url": "./assets/sprites/units/green/grunt/grunt-idle.png",
    "kind": "image",
    "byteSize": 3558
  },
  {
    "url": "./assets/sprites/units/green/grunt/grunt-move.png",
    "kind": "image",
    "byteSize": 13878
  },
  {
    "url": "./assets/sprites/units/green/gunship/gunship-attack.png",
    "kind": "image",
    "byteSize": 6000
  },
  {
    "url": "./assets/sprites/units/green/gunship/gunship-idle.png",
    "kind": "image",
    "byteSize": 4218
  },
  {
    "url": "./assets/sprites/units/green/gunship/gunship-move.png",
    "kind": "image",
    "byteSize": 17562
  },
  {
    "url": "./assets/sprites/units/green/interceptor/interceptor-full.png",
    "kind": "image",
    "byteSize": 166323
  },
  {
    "url": "./assets/sprites/units/green/juggernaut/juggernaut-attack.png",
    "kind": "image",
    "byteSize": 8133
  },
  {
    "url": "./assets/sprites/units/green/juggernaut/juggernaut-move.png",
    "kind": "image",
    "byteSize": 12429
  },
  {
    "url": "./assets/sprites/units/green/longshot/longshot-attack.png",
    "kind": "image",
    "byteSize": 15813
  },
  {
    "url": "./assets/sprites/units/green/longshot/longshot-idle.png",
    "kind": "image",
    "byteSize": 4281
  },
  {
    "url": "./assets/sprites/units/green/longshot/longshot-move.png",
    "kind": "image",
    "byteSize": 14958
  },
  {
    "url": "./assets/sprites/units/green/mechanic/mechanic-full.png",
    "kind": "image",
    "byteSize": 29958
  },
  {
    "url": "./assets/sprites/units/green/medic/medic-attack.png",
    "kind": "image",
    "byteSize": 6258
  },
  {
    "url": "./assets/sprites/units/green/medic/medic-idle.png",
    "kind": "image",
    "byteSize": 3579
  },
  {
    "url": "./assets/sprites/units/green/medic/medic-move.png",
    "kind": "image",
    "byteSize": 11775
  },
  {
    "url": "./assets/sprites/units/green/payload/payload-full.png",
    "kind": "image",
    "byteSize": 19071
  },
  {
    "url": "./assets/sprites/units/green/runner/runner-attack.png",
    "kind": "image",
    "byteSize": 7272
  },
  {
    "url": "./assets/sprites/units/green/runner/runner-idle.png",
    "kind": "image",
    "byteSize": 8745
  },
  {
    "url": "./assets/sprites/units/green/runner/runner-move.png",
    "kind": "image",
    "byteSize": 16041
  },
  {
    "url": "./assets/sprites/units/green/siege-gun/siege-gun-full.png",
    "kind": "image",
    "byteSize": 30216
  },
  {
    "url": "./assets/sprites/units/green/skyguard/skyguard-attack.png",
    "kind": "image",
    "byteSize": 7896
  },
  {
    "url": "./assets/sprites/units/green/skyguard/skyguard-idle.png",
    "kind": "image",
    "byteSize": 13842
  },
  {
    "url": "./assets/sprites/units/green/skyguard/skyguard-move.png",
    "kind": "image",
    "byteSize": 22665
  },
  {
    "url": "./assets/sprites/units/orange/breaker/breaker-attack.png",
    "kind": "image",
    "byteSize": 6510
  },
  {
    "url": "./assets/sprites/units/orange/breaker/breaker-idle.png",
    "kind": "image",
    "byteSize": 3861
  },
  {
    "url": "./assets/sprites/units/orange/breaker/breaker-move.png",
    "kind": "image",
    "byteSize": 12693
  },
  {
    "url": "./assets/sprites/units/orange/bruiser/bruiser-full.png",
    "kind": "image",
    "byteSize": 98634
  },
  {
    "url": "./assets/sprites/units/orange/carrier.svg",
    "kind": "image",
    "byteSize": 667
  },
  {
    "url": "./assets/sprites/units/orange/grunt/grunt-attack.png",
    "kind": "image",
    "byteSize": 6123
  },
  {
    "url": "./assets/sprites/units/orange/grunt/grunt-idle.png",
    "kind": "image",
    "byteSize": 3627
  },
  {
    "url": "./assets/sprites/units/orange/grunt/grunt-move.png",
    "kind": "image",
    "byteSize": 14112
  },
  {
    "url": "./assets/sprites/units/orange/gunship/gunship-attack.png",
    "kind": "image",
    "byteSize": 6147
  },
  {
    "url": "./assets/sprites/units/orange/gunship/gunship-idle.png",
    "kind": "image",
    "byteSize": 4407
  },
  {
    "url": "./assets/sprites/units/orange/gunship/gunship-move.png",
    "kind": "image",
    "byteSize": 17670
  },
  {
    "url": "./assets/sprites/units/orange/interceptor/interceptor-full.png",
    "kind": "image",
    "byteSize": 166458
  },
  {
    "url": "./assets/sprites/units/orange/juggernaut/juggernaut-attack.png",
    "kind": "image",
    "byteSize": 7977
  },
  {
    "url": "./assets/sprites/units/orange/juggernaut/juggernaut-move.png",
    "kind": "image",
    "byteSize": 12438
  },
  {
    "url": "./assets/sprites/units/orange/longshot/longshot-attack.png",
    "kind": "image",
    "byteSize": 16008
  },
  {
    "url": "./assets/sprites/units/orange/longshot/longshot-idle.png",
    "kind": "image",
    "byteSize": 4284
  },
  {
    "url": "./assets/sprites/units/orange/longshot/longshot-move.png",
    "kind": "image",
    "byteSize": 15045
  },
  {
    "url": "./assets/sprites/units/orange/mechanic/mechanic-full.png",
    "kind": "image",
    "byteSize": 29415
  },
  {
    "url": "./assets/sprites/units/orange/medic/medic-attack.png",
    "kind": "image",
    "byteSize": 6198
  },
  {
    "url": "./assets/sprites/units/orange/medic/medic-idle.png",
    "kind": "image",
    "byteSize": 3615
  },
  {
    "url": "./assets/sprites/units/orange/medic/medic-move.png",
    "kind": "image",
    "byteSize": 12024
  },
  {
    "url": "./assets/sprites/units/orange/payload/payload-full.png",
    "kind": "image",
    "byteSize": 19104
  },
  {
    "url": "./assets/sprites/units/orange/runner/runner-attack.png",
    "kind": "image",
    "byteSize": 7293
  },
  {
    "url": "./assets/sprites/units/orange/runner/runner-idle.png",
    "kind": "image",
    "byteSize": 8715
  },
  {
    "url": "./assets/sprites/units/orange/runner/runner-move.png",
    "kind": "image",
    "byteSize": 15363
  },
  {
    "url": "./assets/sprites/units/orange/siege-gun/siege-gun-full.png",
    "kind": "image",
    "byteSize": 29739
  },
  {
    "url": "./assets/sprites/units/orange/skyguard/skyguard-attack.png",
    "kind": "image",
    "byteSize": 8004
  },
  {
    "url": "./assets/sprites/units/orange/skyguard/skyguard-idle.png",
    "kind": "image",
    "byteSize": 13680
  },
  {
    "url": "./assets/sprites/units/orange/skyguard/skyguard-move.png",
    "kind": "image",
    "byteSize": 21717
  },
  {
    "url": "./assets/sprites/units/purple/breaker.svg",
    "kind": "image",
    "byteSize": 726
  },
  {
    "url": "./assets/sprites/units/purple/breaker/breaker-attack.png",
    "kind": "image",
    "byteSize": 6573
  },
  {
    "url": "./assets/sprites/units/purple/breaker/breaker-idle.png",
    "kind": "image",
    "byteSize": 3831
  },
  {
    "url": "./assets/sprites/units/purple/breaker/breaker-move.png",
    "kind": "image",
    "byteSize": 12459
  },
  {
    "url": "./assets/sprites/units/purple/bruiser.svg",
    "kind": "image",
    "byteSize": 5095
  },
  {
    "url": "./assets/sprites/units/purple/bruiser/bruiser-full.png",
    "kind": "image",
    "byteSize": 101571
  },
  {
    "url": "./assets/sprites/units/purple/carrier.svg",
    "kind": "image",
    "byteSize": 666
  },
  {
    "url": "./assets/sprites/units/purple/grunt.svg",
    "kind": "image",
    "byteSize": 668
  },
  {
    "url": "./assets/sprites/units/purple/grunt/grunt-attack.png",
    "kind": "image",
    "byteSize": 6057
  },
  {
    "url": "./assets/sprites/units/purple/grunt/grunt-idle.png",
    "kind": "image",
    "byteSize": 3627
  },
  {
    "url": "./assets/sprites/units/purple/grunt/grunt-move.png",
    "kind": "image",
    "byteSize": 13983
  },
  {
    "url": "./assets/sprites/units/purple/gunship.svg",
    "kind": "image",
    "byteSize": 664
  },
  {
    "url": "./assets/sprites/units/purple/gunship/gunship-attack.png",
    "kind": "image",
    "byteSize": 5928
  },
  {
    "url": "./assets/sprites/units/purple/gunship/gunship-idle.png",
    "kind": "image",
    "byteSize": 4263
  },
  {
    "url": "./assets/sprites/units/purple/gunship/gunship-move.png",
    "kind": "image",
    "byteSize": 17559
  },
  {
    "url": "./assets/sprites/units/purple/interceptor.svg",
    "kind": "image",
    "byteSize": 606
  },
  {
    "url": "./assets/sprites/units/purple/interceptor/interceptor-full.png",
    "kind": "image",
    "byteSize": 166566
  },
  {
    "url": "./assets/sprites/units/purple/juggernaut.svg",
    "kind": "image",
    "byteSize": 733
  },
  {
    "url": "./assets/sprites/units/purple/juggernaut/juggernaut-attack.png",
    "kind": "image",
    "byteSize": 5472
  },
  {
    "url": "./assets/sprites/units/purple/juggernaut/juggernaut-idle.png",
    "kind": "image",
    "byteSize": 5358
  },
  {
    "url": "./assets/sprites/units/purple/juggernaut/juggernaut-move.png",
    "kind": "image",
    "byteSize": 12429
  },
  {
    "url": "./assets/sprites/units/purple/longshot.svg",
    "kind": "image",
    "byteSize": 669
  },
  {
    "url": "./assets/sprites/units/purple/longshot/longshot-attack.png",
    "kind": "image",
    "byteSize": 15792
  },
  {
    "url": "./assets/sprites/units/purple/longshot/longshot-idle.png",
    "kind": "image",
    "byteSize": 4293
  },
  {
    "url": "./assets/sprites/units/purple/longshot/longshot-move.png",
    "kind": "image",
    "byteSize": 14976
  },
  {
    "url": "./assets/sprites/units/purple/mechanic.svg",
    "kind": "image",
    "byteSize": 1280
  },
  {
    "url": "./assets/sprites/units/purple/mechanic/mechanic-full.png",
    "kind": "image",
    "byteSize": 29562
  },
  {
    "url": "./assets/sprites/units/purple/medic.svg",
    "kind": "image",
    "byteSize": 1276
  },
  {
    "url": "./assets/sprites/units/purple/medic/medic-attack.png",
    "kind": "image",
    "byteSize": 6369
  },
  {
    "url": "./assets/sprites/units/purple/medic/medic-idle.png",
    "kind": "image",
    "byteSize": 3612
  },
  {
    "url": "./assets/sprites/units/purple/medic/medic-move.png",
    "kind": "image",
    "byteSize": 11955
  },
  {
    "url": "./assets/sprites/units/purple/payload.svg",
    "kind": "image",
    "byteSize": 665
  },
  {
    "url": "./assets/sprites/units/purple/payload/payload-full.png",
    "kind": "image",
    "byteSize": 19062
  },
  {
    "url": "./assets/sprites/units/purple/runner.svg",
    "kind": "image",
    "byteSize": 667
  },
  {
    "url": "./assets/sprites/units/purple/runner/runner-attack.png",
    "kind": "image",
    "byteSize": 7317
  },
  {
    "url": "./assets/sprites/units/purple/runner/runner-idle.png",
    "kind": "image",
    "byteSize": 8736
  },
  {
    "url": "./assets/sprites/units/purple/runner/runner-move.png",
    "kind": "image",
    "byteSize": 16251
  },
  {
    "url": "./assets/sprites/units/purple/siege-gun.svg",
    "kind": "image",
    "byteSize": 668
  },
  {
    "url": "./assets/sprites/units/purple/siege-gun/siege-gun-full.png",
    "kind": "image",
    "byteSize": 30210
  },
  {
    "url": "./assets/sprites/units/purple/skyguard.svg",
    "kind": "image",
    "byteSize": 669
  },
  {
    "url": "./assets/sprites/units/purple/skyguard/skyguard-attack.png",
    "kind": "image",
    "byteSize": 7881
  },
  {
    "url": "./assets/sprites/units/purple/skyguard/skyguard-idle.png",
    "kind": "image",
    "byteSize": 13671
  },
  {
    "url": "./assets/sprites/units/purple/skyguard/skyguard-move.png",
    "kind": "image",
    "byteSize": 22374
  },
  {
    "url": "./src/dev/uiHarnessFixtures.js",
    "kind": "script",
    "byteSize": 19731,
    "environment": "development"
  },
  {
    "url": "./src/dev/uiHarnessMain.js",
    "kind": "script",
    "byteSize": 3186,
    "environment": "development"
  },
  {
    "url": "./src/game/app/controllerBattleMethods.js",
    "kind": "script",
    "byteSize": 24928,
    "environment": "development"
  },
  {
    "url": "./src/game/app/controllerFlowMethods.js",
    "kind": "script",
    "byteSize": 18306,
    "environment": "development"
  },
  {
    "url": "./src/game/app/controllerMapEditorMethods.js",
    "kind": "script",
    "byteSize": 42666,
    "environment": "development"
  },
  {
    "url": "./src/game/app/controllerRunMethods.js",
    "kind": "script",
    "byteSize": 30226,
    "environment": "development"
  },
  {
    "url": "./src/game/app/controllerShared.js",
    "kind": "script",
    "byteSize": 4267,
    "environment": "development"
  },
  {
    "url": "./src/game/app/controllerTutorialMethods.js",
    "kind": "script",
    "byteSize": 18401,
    "environment": "development"
  },
  {
    "url": "./src/game/app/GameController.js",
    "kind": "script",
    "byteSize": 6120,
    "environment": "development"
  },
  {
    "url": "./src/game/boot/assetPreloader.js",
    "kind": "script",
    "byteSize": 11138,
    "environment": "development"
  },
  {
    "url": "./src/game/content/buildings.js",
    "kind": "script",
    "byteSize": 4472,
    "environment": "development"
  },
  {
    "url": "./src/game/content/commanderArt.js",
    "kind": "script",
    "byteSize": 2012,
    "environment": "development"
  },
  {
    "url": "./src/game/content/commanders.js",
    "kind": "script",
    "byteSize": 7615,
    "environment": "development"
  },
  {
    "url": "./src/game/content/fieldManual.js",
    "kind": "script",
    "byteSize": 17814,
    "environment": "development"
  },
  {
    "url": "./src/game/content/mapEditor.js",
    "kind": "script",
    "byteSize": 34170,
    "environment": "development"
  },
  {
    "url": "./src/game/content/mapFactory.js",
    "kind": "script",
    "byteSize": 18778,
    "environment": "development"
  },
  {
    "url": "./src/game/content/mapGoals.js",
    "kind": "script",
    "byteSize": 6399,
    "environment": "development"
  },
  {
    "url": "./src/game/content/maps.generated.js",
    "kind": "script",
    "byteSize": 374694,
    "environment": "development"
  },
  {
    "url": "./src/game/content/maps.js",
    "kind": "script",
    "byteSize": 8260,
    "environment": "development"
  },
  {
    "url": "./src/game/content/reinforcements.js",
    "kind": "script",
    "byteSize": 10065,
    "environment": "development"
  },
  {
    "url": "./src/game/content/runUnitNames.js",
    "kind": "script",
    "byteSize": 10533,
    "environment": "development"
  },
  {
    "url": "./src/game/content/runUpgradeConstants.js",
    "kind": "script",
    "byteSize": 34944,
    "environment": "development"
  },
  {
    "url": "./src/game/content/runUpgrades.js",
    "kind": "script",
    "byteSize": 9223,
    "environment": "development"
  },
  {
    "url": "./src/game/content/terrain.js",
    "kind": "script",
    "byteSize": 1909,
    "environment": "development"
  },
  {
    "url": "./src/game/content/tutorial.js",
    "kind": "script",
    "byteSize": 20619,
    "environment": "development"
  },
  {
    "url": "./src/game/content/tutorialConstants.js",
    "kind": "script",
    "byteSize": 775,
    "environment": "development"
  },
  {
    "url": "./src/game/content/tutorialCurriculum.js",
    "kind": "script",
    "byteSize": 44957,
    "environment": "development"
  },
  {
    "url": "./src/game/content/unitCatalog.js",
    "kind": "script",
    "byteSize": 9677,
    "environment": "development"
  },
  {
    "url": "./src/game/content/weaponClasses.js",
    "kind": "script",
    "byteSize": 8315,
    "environment": "development"
  },
  {
    "url": "./src/game/core/battlefieldLayout.js",
    "kind": "script",
    "byteSize": 2768,
    "environment": "development"
  },
  {
    "url": "./src/game/core/buildProfiles.js",
    "kind": "script",
    "byteSize": 2562,
    "environment": "development"
  },
  {
    "url": "./src/game/core/constants.js",
    "kind": "script",
    "byteSize": 3942,
    "environment": "development"
  },
  {
    "url": "./src/game/core/displayOptions.js",
    "kind": "script",
    "byteSize": 4909,
    "environment": "development"
  },
  {
    "url": "./src/game/core/economy.js",
    "kind": "script",
    "byteSize": 292,
    "environment": "development"
  },
  {
    "url": "./src/game/core/emitter.js",
    "kind": "script",
    "byteSize": 706,
    "environment": "development"
  },
  {
    "url": "./src/game/core/generated/unitColorIds.js",
    "kind": "script",
    "byteSize": 187,
    "environment": "development"
  },
  {
    "url": "./src/game/core/id.js",
    "kind": "script",
    "byteSize": 261,
    "environment": "development"
  },
  {
    "url": "./src/game/core/random.js",
    "kind": "script",
    "byteSize": 2228,
    "environment": "development"
  },
  {
    "url": "./src/game/core/unitColors.js",
    "kind": "script",
    "byteSize": 3153,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/assets.js",
    "kind": "script",
    "byteSize": 19474,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/audio/GameAudioDirector.js",
    "kind": "script",
    "byteSize": 7036,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/audio/MusicDirector.js",
    "kind": "script",
    "byteSize": 4712,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/audio/SfxCatalog.js",
    "kind": "script",
    "byteSize": 17895,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/audio/SoundEffectsDirector.js",
    "kind": "script",
    "byteSize": 7941,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/createGame.js",
    "kind": "script",
    "byteSize": 10816,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/generated/buildingSpritePngOwners.js",
    "kind": "script",
    "byteSize": 265,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/generated/terrainSpritePngIds.js",
    "kind": "script",
    "byteSize": 281,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/generated/unitSpriteAnimations.js",
    "kind": "script",
    "byteSize": 99575,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/BattleScene.js",
    "kind": "script",
    "byteSize": 2768,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/battleScene/cameraControls.js",
    "kind": "script",
    "byteSize": 17486,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/battleScene/gamepadControls.js",
    "kind": "script",
    "byteSize": 6694,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/battleScene/pointerControls.js",
    "kind": "script",
    "byteSize": 10212,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/battleScene/renderBoard.js",
    "kind": "script",
    "byteSize": 26893,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/battleScene/screenState.js",
    "kind": "script",
    "byteSize": 2861,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/BootScene.js",
    "kind": "script",
    "byteSize": 9709,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/scenes/ShellScene.js",
    "kind": "script",
    "byteSize": 2009,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/unitSpritePresentation.js",
    "kind": "script",
    "byteSize": 1407,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/battleAnimationEvents.js",
    "kind": "script",
    "byteSize": 27652,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/battleAudioRouting.js",
    "kind": "script",
    "byteSize": 3122,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/battleCombatCutscene.js",
    "kind": "script",
    "byteSize": 11816,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/BattleFxLayer.js",
    "kind": "script",
    "byteSize": 29137,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/BuildingLayer.js",
    "kind": "script",
    "byteSize": 2586,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/grayscaleTexture.js",
    "kind": "script",
    "byteSize": 2464,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/GridLayer.js",
    "kind": "script",
    "byteSize": 15461,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/MenuBackdropLayer.js",
    "kind": "script",
    "byteSize": 716,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/ownerPalette.js",
    "kind": "script",
    "byteSize": 267,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/SelectionLayer.js",
    "kind": "script",
    "byteSize": 30438,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/selectionPathAnimation.js",
    "kind": "script",
    "byteSize": 4313,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/selectionTooltip.js",
    "kind": "script",
    "byteSize": 2153,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/terrainClusters.js",
    "kind": "script",
    "byteSize": 1968,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/terrainTransitions.js",
    "kind": "script",
    "byteSize": 1360,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/unitAnimationHelpers.js",
    "kind": "script",
    "byteSize": 7717,
    "environment": "development"
  },
  {
    "url": "./src/game/phaser/view/UnitLayer.js",
    "kind": "script",
    "byteSize": 53880,
    "environment": "development"
  },
  {
    "url": "./src/game/services/StorageRepository.js",
    "kind": "script",
    "byteSize": 4967,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/airStrike.js",
    "kind": "script",
    "byteSize": 4185,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/battleLog.js",
    "kind": "script",
    "byteSize": 1745,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/battlePresentation.js",
    "kind": "script",
    "byteSize": 34107,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/battleServicing.js",
    "kind": "script",
    "byteSize": 3795,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/battleSystem.js",
    "kind": "script",
    "byteSize": 13029,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/battleUnits.js",
    "kind": "script",
    "byteSize": 758,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/captureRules.js",
    "kind": "script",
    "byteSize": 1021,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/combatResolver.js",
    "kind": "script",
    "byteSize": 11173,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/combatResources.js",
    "kind": "script",
    "byteSize": 473,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/commanderEffects.js",
    "kind": "script",
    "byteSize": 30971,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/debugActions.js",
    "kind": "script",
    "byteSize": 7496,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi.js",
    "kind": "script",
    "byteSize": 868,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi/attackScoring.js",
    "kind": "script",
    "byteSize": 5274,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi/movementScoring.js",
    "kind": "script",
    "byteSize": 27882,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi/profiles.js",
    "kind": "script",
    "byteSize": 1371,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi/recruitment.js",
    "kind": "script",
    "byteSize": 6498,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi/shared.js",
    "kind": "script",
    "byteSize": 3516,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi/transportPlans.js",
    "kind": "script",
    "byteSize": 5998,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/enemyAi/turnPlanning.js",
    "kind": "script",
    "byteSize": 20212,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/missionRules.js",
    "kind": "script",
    "byteSize": 15105,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/playerActions.js",
    "kind": "script",
    "byteSize": 994,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/playerActions/combatAction.js",
    "kind": "script",
    "byteSize": 18815,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/playerActions/pendingActionFlow.js",
    "kind": "script",
    "byteSize": 11675,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/playerActions/recruitmentActions.js",
    "kind": "script",
    "byteSize": 3966,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/playerActions/selectionFlow.js",
    "kind": "script",
    "byteSize": 9828,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/playerActions/shared.js",
    "kind": "script",
    "byteSize": 1315,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/playerActions/supportActions.js",
    "kind": "script",
    "byteSize": 6146,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/progression.js",
    "kind": "script",
    "byteSize": 6069,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/reinforcementRules.js",
    "kind": "script",
    "byteSize": 10152,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/runCardEffects.js",
    "kind": "script",
    "byteSize": 28038,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/selectors.js",
    "kind": "script",
    "byteSize": 14852,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/supportScoring.js",
    "kind": "script",
    "byteSize": 767,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/transportRules.js",
    "kind": "script",
    "byteSize": 4428,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/turnFlow.js",
    "kind": "script",
    "byteSize": 37946,
    "environment": "development"
  },
  {
    "url": "./src/game/simulation/unitFactory.js",
    "kind": "script",
    "byteSize": 3534,
    "environment": "development"
  },
  {
    "url": "./src/game/state/defaults.js",
    "kind": "script",
    "byteSize": 2669,
    "environment": "development"
  },
  {
    "url": "./src/game/state/deployment.js",
    "kind": "script",
    "byteSize": 6386,
    "environment": "development"
  },
  {
    "url": "./src/game/state/enemyScaling.js",
    "kind": "script",
    "byteSize": 1438,
    "environment": "development"
  },
  {
    "url": "./src/game/state/runFactory.js",
    "kind": "script",
    "byteSize": 19615,
    "environment": "development"
  },
  {
    "url": "./src/game/state/tutorialProgress.js",
    "kind": "script",
    "byteSize": 2812,
    "environment": "development"
  },
  {
    "url": "./src/main.js",
    "kind": "script",
    "byteSize": 2087,
    "environment": "development"
  },
  {
    "url": "./src/styles/base/animations.css",
    "kind": "style",
    "byteSize": 10612,
    "environment": "development"
  },
  {
    "url": "./src/styles/base/app-version.css",
    "kind": "style",
    "byteSize": 549,
    "environment": "development"
  },
  {
    "url": "./src/styles/base/foundation.css",
    "kind": "style",
    "byteSize": 17577,
    "environment": "development"
  },
  {
    "url": "./src/styles/base/interaction-modes.css",
    "kind": "style",
    "byteSize": 1637,
    "environment": "development"
  },
  {
    "url": "./src/styles/battle/commander-panels.css",
    "kind": "style",
    "byteSize": 33828,
    "environment": "development"
  },
  {
    "url": "./src/styles/battle/intel-and-selection.css",
    "kind": "style",
    "byteSize": 19364,
    "environment": "development"
  },
  {
    "url": "./src/styles/battle/layout.css",
    "kind": "style",
    "byteSize": 22936,
    "environment": "development"
  },
  {
    "url": "./src/styles/battle/overlays-and-debug.css",
    "kind": "style",
    "byteSize": 52614,
    "environment": "development"
  },
  {
    "url": "./src/styles/main.css",
    "kind": "style",
    "byteSize": 639,
    "environment": "development"
  },
  {
    "url": "./src/styles/responsive/layout.css",
    "kind": "style",
    "byteSize": 54096,
    "environment": "development"
  },
  {
    "url": "./src/styles/scenes/run-loadout.css",
    "kind": "style",
    "byteSize": 12613,
    "environment": "development"
  },
  {
    "url": "./src/styles/scenes/setup.css",
    "kind": "style",
    "byteSize": 20956,
    "environment": "development"
  },
  {
    "url": "./src/styles/scenes/title-backdrop.css",
    "kind": "style",
    "byteSize": 292,
    "environment": "development"
  },
  {
    "url": "./src/styles/scenes/tutorial-utility.css",
    "kind": "style",
    "byteSize": 20577,
    "environment": "development"
  },
  {
    "url": "./src/styles/shared/chrome.css",
    "kind": "style",
    "byteSize": 24690,
    "environment": "development"
  },
  {
    "url": "./src/styles/tools/map-editor.css",
    "kind": "style",
    "byteSize": 19810,
    "environment": "development"
  },
  {
    "url": "./src/ui/AppShell.js",
    "kind": "script",
    "byteSize": 5773,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/audioFeedback.js",
    "kind": "script",
    "byteSize": 5478,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/commanderSliderMethods.js",
    "kind": "script",
    "byteSize": 7983,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/displayMethods.js",
    "kind": "script",
    "byteSize": 15245,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/eventMethods.js",
    "kind": "script",
    "byteSize": 37651,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/inputMethods.js",
    "kind": "script",
    "byteSize": 19819,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/render/battleMeters.js",
    "kind": "script",
    "byteSize": 5152,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/render/battlePresentationPlayback.js",
    "kind": "script",
    "byteSize": 17688,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/render/battleScreen.js",
    "kind": "script",
    "byteSize": 21750,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/render/combatCutscene.js",
    "kind": "script",
    "byteSize": 14645,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/render/screenRouter.js",
    "kind": "script",
    "byteSize": 10709,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/render/uiStatePersistence.js",
    "kind": "script",
    "byteSize": 9028,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/renderMethods.js",
    "kind": "script",
    "byteSize": 743,
    "environment": "development"
  },
  {
    "url": "./src/ui/appShell/shared.js",
    "kind": "script",
    "byteSize": 1484,
    "environment": "development"
  },
  {
    "url": "./src/ui/formatters.js",
    "kind": "script",
    "byteSize": 657,
    "environment": "development"
  },
  {
    "url": "./src/ui/shared/html.js",
    "kind": "script",
    "byteSize": 294,
    "environment": "development"
  },
  {
    "url": "./src/ui/shared/unitStatPresentation.js",
    "kind": "script",
    "byteSize": 7217,
    "environment": "development"
  },
  {
    "url": "./src/ui/unitColorTheme.js",
    "kind": "script",
    "byteSize": 621,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/appToastView.js",
    "kind": "script",
    "byteSize": 307,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/battleHud/combatCutsceneOverlay.js",
    "kind": "script",
    "byteSize": 14169,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/battleHud/commanderPanels.js",
    "kind": "script",
    "byteSize": 10871,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/battleHud/interactionPanels.js",
    "kind": "script",
    "byteSize": 28490,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/battleHud/overlays.js",
    "kind": "script",
    "byteSize": 25888,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/battleHud/selectionPanels.js",
    "kind": "script",
    "byteSize": 22541,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/battleHud/tutorialGuide.js",
    "kind": "script",
    "byteSize": 2597,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/battleHudView.js",
    "kind": "script",
    "byteSize": 16226,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/commanderSelectView.js",
    "kind": "script",
    "byteSize": 7833,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/mapEditorView.js",
    "kind": "script",
    "byteSize": 59184,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/optionFieldsView.js",
    "kind": "script",
    "byteSize": 13538,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/optionsView.js",
    "kind": "script",
    "byteSize": 707,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/progressionView.js",
    "kind": "script",
    "byteSize": 2803,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/runLoadoutView.js",
    "kind": "script",
    "byteSize": 18149,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/saveSlotView.js",
    "kind": "script",
    "byteSize": 2008,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/skirmishSetupView.js",
    "kind": "script",
    "byteSize": 10066,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/titleView.js",
    "kind": "script",
    "byteSize": 20915,
    "environment": "development"
  },
  {
    "url": "./src/ui/views/tutorialView.js",
    "kind": "script",
    "byteSize": 9069,
    "environment": "development"
  }
];

export const ASSET_PRELOAD_TOTAL_BYTES = 109495340;
